export class RecipientModel {
  waitingFunds: number;
  available: number;
  transferred: number;
}
